
define(
	'Tavanoteam.QuantityIncrement.QuantityIncrement'
	, [
		'Tavanoteam.QuantityIncrement.QuantityIncrement.Model'
		, 'Cart.Detailed.View'
		, 'Cart.Item.Summary.View'

		, 'jQuery'
		, 'underscore'
	]
	, function (
		QuantityIncrementModel
		, CartDetailedView
		, CartItemSummaryView

		, jQuery
		, _
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var pdpComponent = container.getComponent('PDP'),
					cartComponent = container.getComponent('Cart'),
					searchComponent = container.getComponent('Search');

				//Error handler for PDP Quantity when value is not in the multiple of the set increments
				if (pdpComponent) {
					pdpComponent.cancelableOn('beforeQuantityChange', function rejectInvalidQuantity(quantity) {

						//Get Item Quantity Increment
						var itemInfo = pdpComponent.getItemInfo();
						var itemOption = pdpComponent.getSelectedMatrixChilds();

						var item_qty = itemInfo.item.custitem_qty_increment;
						var quantityIncrement = 1;

						if (itemOption.length > 0) {
							var itemOption_qty = itemOption[0].custitem_qty_increment;
							quantityIncrement = itemOption_qty ? itemOption_qty : item_qty;
						} else {
							quantityIncrement = item_qty ? item_qty : 1;
						}

						//If valid quantity increment
						var	isInvalid = (quantity % quantityIncrement) != 0 ? true : false,
							isNull = quantity == 0;
						
						if (isInvalid || isNull) {

							pdpComponent.setQuantity(quantityIncrement);

							if (!isNull) {
								pdpComponent.showMessage({
									message: 'Invalid Quantity. Please order in multiples of ' + quantityIncrement,
									type: 'error',
									selector: 'QuantityError',
									timeout: 5000
								});
							}
								
							return new jQuery.Deferred().reject();

						} 

					});

					//If Matrix Item is selected
					pdpComponent.cancelableOn('afterOptionSelection', function () {

						//Get Item Quantity Increment
						var itemInfo = pdpComponent.getItemInfo();
						var itemOption = pdpComponent.getSelectedMatrixChilds();

						var item_qty = itemInfo.item.custitem_qty_increment;
						var itemOption_qty = itemOption[0].custitem_qty_increment;

						var quantityIncrement = itemOption_qty ? itemOption_qty : item_qty;

						//Change Increment
						jQuery('.product-details-quantity-add').attr('data-value', '+' + quantityIncrement);
						jQuery('.product-details-quantity-remove').attr('data-value', '-' + quantityIncrement);
						jQuery('.product-details-quantity-add').data('value', '+' + quantityIncrement);
						jQuery('.product-details-quantity-remove').data('value', '-' + quantityIncrement);
						jQuery('.product-details-quantity-increment').text(quantityIncrement);
						pdpComponent.setQuantity(quantityIncrement);

					});

					//If Matrix Item is loaded
					pdpComponent.addToViewContextDefinition('ProductDetails.Quantity.View', 'quantityIncrement', 'string', function(context) {
	
						//Get Item Quantity Increment
						var itemInfo = pdpComponent.getItemInfo();
						var itemOption = pdpComponent.getSelectedMatrixChilds();

						var item_qty = itemInfo.item.custitem_qty_increment;

						var quantityIncrement = 1;

						if (itemOption.length > 0) {
							var itemOption_qty = itemOption[0].custitem_qty_increment;
							quantityIncrement = itemOption_qty ? itemOption_qty : item_qty;
						} else {
							quantityIncrement = item_qty ? item_qty : 1;
						}

						pdpComponent.setQuantity(quantityIncrement);
						
						return quantityIncrement;

					});

				}

				//Error handler for Cart Quantity when value is not in the multiple of the set increments
				if (cartComponent) {
					//Return an error message and reset to the correct value when number entered is invalid
					_.extend(CartDetailedView.prototype, {
						debouncedUpdateItemQuantity: _.debounce(function (e) {
							var self = this
								, $line = null
								, $form = jQuery(e.target).closest('form')
								, options = $form.serializeObject()
								, internalid = options.internalid
								, line = this.model.get('lines').get(internalid)
								, $input = $form.find('[name="quantity"]')
								, item = line.get('item')
								, quantity = $input.val()
								, hasParent =  item && item.get('matrix_parent') ? true : false
								, hasQuantityIncrement = item && item.get('custitem_qty_increment') ? true : false
								, quantityIncrement = '';

							//Get Quantity Increment from Parent if item is a Child Matrix
							if (hasParent && !hasQuantityIncrement) {
								quantityIncrement = item && item.get('matrix_parent').custitem_qty_increment ? item.get('matrix_parent').custitem_qty_increment : 1;
							}
							else {
								quantityIncrement = item && item.get('custitem_qty_increment') ? item.get('custitem_qty_increment') : 1;
							}

							var isInvalid = (quantity % quantityIncrement) != 0 ? true : false;
							var isNull = quantity == 0 || quantity == null;

							if (isInvalid) {
								cartComponent.showMessage({
									message: 'Invalid Quantity. Please order in multiples of ' + quantityIncrement,
									type: 'error',
									selector: 'QuantityError-' + line.id,
									timeout: 5000
								});

								$input.val(quantityIncrement);
								this.updateItemQuantity(e);

							}
							if (isNull) {
								cartComponent.showMessage({
									message: 'Invalid Quantity. Minimum quantity should be ' + quantityIncrement,
									type: 'error',
									selector: 'QuantityError-' + line.id,
									timeout: 5000
								});

								$input.val(quantityIncrement);
								this.updateItemQuantity(e);

							}
							else {
								this.updateItemQuantity(e);
							}
						}, 1000)
					});

					//Error handler for add/subtract for mobile view
					_.extend(CartItemSummaryView.prototype, {
						addQuantity: function(e) {
							e.preventDefault();
					
							var $element = this.$(e.target);
							var quantity_input = $element.parent().find('input');
							var old_value = quantity_input.val();
							var max_quantity = this.model.get('item').get('_maximumQuantity', true);
							var hasParent =  this.model.get('item').get('matrix_parent') ? true : false
							var hasQuantityIncrement = this.model.get('item').get('custitem_qty_increment') ? true : false
							var incrementQuantity = '';

							//Get Quantity Increment from Parent if item is a Child Matrix
							if (hasParent && !hasQuantityIncrement) {
								incrementQuantity =  this.model.get('item').get('matrix_parent').custitem_qty_increment ? this.model.get('item').get('matrix_parent').custitem_qty_increment : 1;
							}
							else {
								incrementQuantity = this.model.get('item').get('custitem_qty_increment') ? this.model.get('item').get('custitem_qty_increment') : 1;
							}

							var new_val = parseFloat(old_value) + incrementQuantity;
					
							new_val = max_quantity ? Math.min(max_quantity, new_val) : new_val;
					
							quantity_input.val(new_val);
							quantity_input.change();
						},

						subQuantity: function(e) {
							e.preventDefault();
					
							var $element = this.$(e.target);
							var quantity_input = $element.parent().find('input');
							var old_value = quantity_input.val();
							var hasParent =  this.model.get('item').get('matrix_parent') ? true : false
							var hasQuantityIncrement = this.model.get('item').get('custitem_qty_increment') ? true : false
							var decrementQuantity = '';

							//Get Quantity Decrement from Parent if item is a Child Matrix
							if (hasParent && !hasQuantityIncrement) {
								decrementQuantity =  this.model.get('item').get('matrix_parent').custitem_qty_increment ? this.model.get('item').get('matrix_parent').custitem_qty_increment : 1;
							}
							else {
								decrementQuantity = this.model.get('item').get('custitem_qty_increment') ? this.model.get('item').get('custitem_qty_increment') : 1;
							}

							var new_val = parseFloat(old_value) - decrementQuantity;
					
							new_val = Math.max(this.model.get('item').get('_minimumQuantity', true), new_val);
					
							quantity_input.val(new_val);
							quantity_input.change();
						},
					});
				}

			}
		};
	});
